import './assets/index49.css';var xo = Object.defineProperty, _o = Object.defineProperties;
var yo = Object.getOwnPropertyDescriptors;
var w = Object.getOwnPropertySymbols;
var Z = Object.prototype.hasOwnProperty, oo = Object.prototype.propertyIsEnumerable;
var Y = (o, r, e) => r in o ? xo(o, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : o[r] = e, t = (o, r) => {
  for (var e in r || (r = {}))
    Z.call(r, e) && Y(o, e, r[e]);
  if (w)
    for (var e of w(r))
      oo.call(r, e) && Y(o, e, r[e]);
  return o;
}, m = (o, r) => _o(o, yo(r));
var S = (o, r) => {
  var e = {};
  for (var s in o)
    Z.call(o, s) && r.indexOf(s) < 0 && (e[s] = o[s]);
  if (o != null && w)
    for (var s of w(o))
      r.indexOf(s) < 0 && oo.call(o, s) && (e[s] = o[s]);
  return e;
};
import { jsx as u, jsxs as eo } from "react/jsx-runtime";
import { useContext as go, createContext as Io, useRef as Go, useEffect as Po, forwardRef as No } from "react";
import { ErrorMessage as Ro } from "./molecules/ErrorMessage/index.js";
import { Label as zo } from "./components/Label/index.js";
import { u as j } from "./use-uncontrolled-BT_j5D2R.js";
import { e as W, c as ro } from "./get-size-Bc1Pz5yf.js";
import { c as F } from "./create-vars-resolver-Bzbn9G-G.js";
import { f as B, u as E, B as U, p as so, h as T, e as So } from "./factory-ueRxoNOV.js";
import { g as co } from "./get-contrast-color-SC35uhiM.js";
import { g as to } from "./get-auto-contrast-value-BGSSZ1GD.js";
import { u as J } from "./use-styles-DToiHEa6.js";
import { I as Vo, a as $o, b as wo } from "./InputsGroupFieldset-Bo-BOy1U.js";
import { U as To } from "./UnstyledButton-D9OCzDhz.js";
import { c as Bo } from "./create-optional-context-CQ2ahjKQ.js";
import { I as ao } from "./Input--FNE961U.js";
import { a as no } from "./CheckIcon-DkmKiN6y.js";
import { u as Eo } from "./use-id-D2tGiO9x.js";
const lo = Io(null), Ao = lo.Provider, io = () => go(lo), [Oo, Uo] = Bo();
var uo = { card: "m_26775b0a" };
const jo = {
  withBorder: !0
}, Wo = F((o, { radius: r }) => ({
  card: {
    "--card-radius": W(r)
  }
})), L = B((o, r) => {
  const e = E("CheckboxCard", jo, o), _ = e, {
    classNames: s,
    className: n,
    style: l,
    styles: a,
    unstyled: c,
    vars: d,
    checked: C,
    mod: i,
    withBorder: y,
    value: g,
    onClick: f,
    defaultChecked: v,
    onChange: p
  } = _, x = S(_, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "checked",
    "mod",
    "withBorder",
    "value",
    "onClick",
    "defaultChecked",
    "onChange"
  ]), I = J({
    name: "CheckboxCard",
    classes: uo,
    props: e,
    className: n,
    style: l,
    classNames: s,
    styles: a,
    unstyled: c,
    vars: d,
    varsResolver: Wo,
    rootSelector: "card"
  }), h = io(), G = typeof C == "boolean" ? C : h ? h.value.includes(g || "") : void 0, [b, k] = j({
    value: G,
    defaultValue: v,
    finalValue: !1,
    onChange: p
  });
  return /* @__PURE__ */ u(Oo, { value: { checked: b }, children: /* @__PURE__ */ u(
    To,
    m(t(t({
      ref: r,
      mod: [{ "with-border": y, checked: b }, i]
    }, I("card")), x), {
      role: "checkbox",
      "aria-checked": b,
      onClick: (z) => {
        f == null || f(z), h == null || h.onChange(g || ""), k(!b);
      }
    })
  ) });
});
L.displayName = "@mantine/core/CheckboxCard";
L.classes = uo;
const Fo = {}, M = B((o, r) => {
  const f = E("CheckboxGroup", Fo, o), { value: e, defaultValue: s, onChange: n, size: l, wrapperProps: a, children: c, readOnly: d } = f, C = S(f, ["value", "defaultValue", "onChange", "size", "wrapperProps", "children", "readOnly"]), [i, y] = j({
    value: e,
    defaultValue: s,
    finalValue: [],
    onChange: n
  });
  return /* @__PURE__ */ u(Ao, { value: { value: i, onChange: (v) => {
    const p = typeof v == "string" ? v : v.currentTarget.value;
    !d && y(
      i.includes(p) ? i.filter((x) => x !== p) : [...i, p]
    );
  }, size: l }, children: /* @__PURE__ */ u(
    ao.Wrapper,
    m(t(t({
      size: l,
      ref: r
    }, a), C), {
      labelElement: "div",
      __staticSelector: "CheckboxGroup",
      children: /* @__PURE__ */ u(Vo, { role: "group", children: c })
    })
  ) });
});
M.classes = ao.Wrapper.classes;
M.displayName = "@mantine/core/CheckboxGroup";
var po = { indicator: "m_5e5256ee", icon: "m_1b1c543a", "indicator--outline": "m_76e20374" };
const Jo = {
  icon: no
}, Lo = F(
  (o, { radius: r, color: e, size: s, iconColor: n, variant: l, autoContrast: a }) => {
    const c = so({ color: e || o.primaryColor, theme: o }), d = c.isThemeColor && c.shade === void 0 ? `var(--mantine-color-${c.color}-outline)` : c.color;
    return {
      indicator: {
        "--checkbox-size": ro(s, "checkbox-size"),
        "--checkbox-radius": r === void 0 ? void 0 : W(r),
        "--checkbox-color": l === "outline" ? d : T(e, o),
        "--checkbox-icon-color": n ? T(n, o) : to(a, o) ? co({ color: e, theme: o, autoContrast: a }) : void 0
      }
    };
  }
), q = B((o, r) => {
  const e = E("CheckboxIndicator", Jo, o), A = e, {
    classNames: s,
    className: n,
    style: l,
    styles: a,
    unstyled: c,
    vars: d,
    icon: C,
    indeterminate: i,
    radius: y,
    color: g,
    iconColor: f,
    autoContrast: v,
    checked: p,
    mod: x,
    variant: I,
    disabled: h
  } = A, G = S(A, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "icon",
    "indeterminate",
    "radius",
    "color",
    "iconColor",
    "autoContrast",
    "checked",
    "mod",
    "variant",
    "disabled"
  ]), b = C, k = J({
    name: "CheckboxIndicator",
    classes: po,
    props: e,
    className: n,
    style: l,
    classNames: s,
    styles: a,
    unstyled: c,
    vars: d,
    varsResolver: Lo,
    rootSelector: "indicator"
  }), _ = Uo(), z = typeof p == "boolean" || typeof i == "boolean" ? p || i : (_ == null ? void 0 : _.checked) || !1;
  return /* @__PURE__ */ u(
    U,
    m(t(m(t({
      ref: r
    }, k("indicator", { variant: I })), {
      variant: I,
      mod: [{ checked: z, disabled: h }, x]
    }), G), {
      children: /* @__PURE__ */ u(b, t({ indeterminate: i }, k("icon")))
    })
  );
});
q.displayName = "@mantine/core/CheckboxIndicator";
q.classes = po;
var ho = { root: "m_bf2d988c", inner: "m_26062bec", input: "m_26063560", icon: "m_bf295423", "input--outline": "m_215c4542" };
const Mo = {
  labelPosition: "right",
  icon: no
}, qo = F(
  (o, { radius: r, color: e, size: s, iconColor: n, variant: l, autoContrast: a }) => {
    const c = so({ color: e || o.primaryColor, theme: o }), d = c.isThemeColor && c.shade === void 0 ? `var(--mantine-color-${c.color}-outline)` : c.color;
    return {
      root: {
        "--checkbox-size": ro(s, "checkbox-size"),
        "--checkbox-radius": r === void 0 ? void 0 : W(r),
        "--checkbox-color": l === "outline" ? d : T(e, o),
        "--checkbox-icon-color": n ? T(n, o) : to(a, o) ? co({ color: e, theme: o, autoContrast: a }) : void 0
      }
    };
  }
), R = B((o, r) => {
  const e = E("Checkbox", Mo, o), Q = e, {
    classNames: s,
    className: n,
    style: l,
    styles: a,
    unstyled: c,
    vars: d,
    color: C,
    label: i,
    id: y,
    size: g,
    radius: f,
    wrapperProps: v,
    checked: p,
    labelPosition: x,
    description: I,
    error: h,
    disabled: G,
    variant: b,
    indeterminate: k,
    icon: _,
    rootRef: z,
    iconColor: A,
    onChange: V,
    autoContrast: Xo,
    mod: mo
  } = Q, Co = S(Q, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "color",
    "label",
    "id",
    "size",
    "radius",
    "wrapperProps",
    "checked",
    "labelPosition",
    "description",
    "error",
    "disabled",
    "variant",
    "indeterminate",
    "icon",
    "rootRef",
    "iconColor",
    "onChange",
    "autoContrast",
    "mod"
  ]), P = io(), bo = g || (P == null ? void 0 : P.size), ko = _, $ = J({
    name: "Checkbox",
    props: e,
    classes: ho,
    className: n,
    style: l,
    classNames: s,
    styles: a,
    unstyled: c,
    vars: d,
    varsResolver: qo
  }), { styleProps: fo, rest: D } = So(Co), H = Eo(y), K = P ? {
    checked: P.value.includes(D.value),
    onChange: (X) => {
      P.onChange(X), V == null || V(X);
    }
  } : {}, vo = Go(null), N = r || vo;
  return Po(() => {
    N && "current" in N && N.current && (N.current.indeterminate = k || !1);
  }, [k, N]), /* @__PURE__ */ u(
    $o,
    m(t(t(m(t({}, $("root")), {
      __staticSelector: "Checkbox",
      __stylesApiProps: e,
      id: H,
      size: bo,
      labelPosition: x,
      label: i,
      description: I,
      error: h,
      disabled: G,
      classNames: s,
      styles: a,
      unstyled: c,
      "data-checked": K.checked || p || void 0,
      variant: b,
      ref: z,
      mod: mo
    }), fo), v), {
      children: /* @__PURE__ */ eo(U, m(t({}, $("inner")), { mod: { "data-label-position": x }, children: [
        /* @__PURE__ */ u(
          U,
          m(t(t(m(t({
            component: "input",
            id: H,
            ref: N,
            checked: p,
            disabled: G,
            mod: { error: !!h, indeterminate: k }
          }, $("input", { focusable: !0, variant: b })), {
            onChange: V
          }), D), K), {
            type: "checkbox"
          })
        ),
        /* @__PURE__ */ u(ko, t({ indeterminate: k }, $("icon")))
      ] }))
    })
  );
});
R.classes = t(t({}, ho), wo);
R.displayName = "@mantine/core/Checkbox";
R.Group = M;
R.Indicator = q;
R.Card = L;
const Do = "CheckboxGroup-module__root___r0tTu", Ho = "CheckboxGroup-module__container___uEOq9", Ko = "CheckboxGroup-module__label___wEJar", O = {
  root: Do,
  container: Ho,
  label: Ko
}, Qo = No(({
  label: o,
  orientation: r = "vertical",
  required: e,
  error: s,
  children: n,
  value: l,
  defaultValue: a,
  onChange: c
}, d) => {
  const [C, i] = j({
    value: l,
    defaultValue: a || [],
    onChange: c
  });
  return /* @__PURE__ */ eo("div", { className: O.container, children: [
    /* @__PURE__ */ u(
      R.Group,
      {
        label: typeof o == "string" ? /* @__PURE__ */ u(zo, { label: o }) : o,
        value: C,
        onChange: i,
        ref: d,
        classNames: {
          root: O.root,
          label: O.label
        },
        mod: {
          orientation: r,
          required: e
        },
        withAsterisk: e,
        children: n
      }
    ),
    s && /* @__PURE__ */ u(Ro, { error: s })
  ] });
});
Qo.displayName = "Checkbox.Group";
export {
  R as C,
  Qo as G
};
